const iconSize = {
  large: 40,
  medium: 30,
  small: 20,
  xSmall: 16
};

export { iconSize };
